function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect, { Async } from 'react-select';
import cx from 'classnames';
import TetherSelect from "./tether-select/tether-select";
import noop from "../../utils/noop";

var propTypes = _objectSpread({
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputProps: PropTypes.object,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })),
  menuRenderer: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  qaid: PropTypes.string,
  selectType: PropTypes.oneOf(['select', 'tether', 'async']),
  tetherProps: PropTypes.object,
  multi: PropTypes.bool,
  dropUpIfOutOfViewport: PropTypes.bool
}, ReactSelect.propTypes);

var handleChange = function handleChange(onChange) {
  return function (selection) {
    return onChange(selection && selection.value);
  };
};

var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function () {
      window.requestAnimationFrame(function () {
        if (!_this.selectComponent) return;
        var viewportBottom = window.innerHeight || document.documentElement.clientHeight;

        var dropdown = _this.selectComponent.wrapper.querySelector('.Select-menu-outer');

        _this.flipDropdownIfOutOfViewport(dropdown, viewportBottom);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "flipDropdownIfOutOfViewport", function (dropdown, viewportBottom) {
      var boundingRect = dropdown.getBoundingClientRect(); // eslint-disable-next-line no-param-reassign, max-len

      if (boundingRect.bottom > viewportBottom) dropdown.style.top = "".concat(boundingRect.height * -1, "px");
    });

    return _this;
  }

  _createClass(SelectInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          containerClassName = _this$props.containerClassName,
          id = _this$props.id,
          inputProps = _this$props.inputProps,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          options = _this$props.options,
          menuRenderer = _this$props.menuRenderer,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          required = _this$props.required,
          qaid = _this$props.qaid,
          multi = _this$props.multi,
          selectType = _this$props.selectType,
          tetherProps = _this$props.tetherProps,
          dropUpIfOutOfViewport = _this$props.dropUpIfOutOfViewport,
          props = _objectWithoutProperties(_this$props, ["className", "containerClassName", "id", "inputProps", "placeholder", "value", "options", "menuRenderer", "onChange", "disabled", "required", "qaid", "multi", "selectType", "tetherProps", "dropUpIfOutOfViewport"]);

      var SelectComponent = TetherSelect;
      var isAsync = selectType === 'async';
      if (selectType === 'select') SelectComponent = ReactSelect;else if (isAsync) SelectComponent = Async;
      if (dropUpIfOutOfViewport) if (props.onOpen) {
        var oldOnOpen = props.onOpen;

        props.onOpen = function () {
          oldOnOpen();

          _this2.handleOnOpen();
        };
      } else props.onOpen = this.handleOnOpen;
      return React.createElement("div", {
        id: qaid,
        className: containerClassName
      }, React.createElement(SelectComponent, _extends({
        className: cx('SelectInput-select', className),
        inputProps: _objectSpread({
          id: id
        }, inputProps),
        placeholder: placeholder,
        value: value,
        options: options,
        menuRenderer: menuRenderer,
        onChange: multi || isAsync ? onChange : handleChange(onChange),
        disabled: disabled,
        required: required,
        id: id,
        multi: multi
      }, props, {
        tetherProps: tetherProps,
        ref: function ref(input) {
          _this2.selectComponent = input;
        }
      })));
    }
  }]);

  return SelectInput;
}(React.Component);

SelectInput.displayName = 'SelectInput';
SelectInput.propTypes = propTypes;
SelectInput.defaultProps = {
  onChange: noop,
  selectType: 'select',
  multi: false,
  dropUpIfOutOfViewport: false
};
export default SelectInput;